const companyInfo = {
  name: "ゼロワン合同会社",
  owner: "許 紅",
  create: "２０２３年２月２８日",
  capital: "500万円",
  zip: "〒１０５-００１３",
  address: "東京都港区浜松町２丁目２番１５号",
  addr2: "浜松町ダイヤビル２F",
  email: "xh@zerone-inf.com",
  website: "https://www.zerone-inf.com",
};
export default companyInfo;
